<div class="form-group" [formGroup]="group">
    <label>{{field.label}}</label>
    <app-date-time-picker  [originalDate]="date" (onDateChange)="onDateTimeChange($event)" [ngClass]="{'custom-field-invalid': group.get(field.name).invalid}"></app-date-time-picker>

    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>
</div>
